module.exports = __webpack_public_path__ + "a9bb81fc0f89f033cb2cef07d50a8925.svg";